import React, { useRef, useState } from 'react'
import ReactGA from 'react-ga'
import ym from 'react-yandex-metrika'

import NewFlatCardTwoStates from '../NewFlatCardTwoStates/NewFlatCardTwoStates'
import {
  NewFlatCardTwoStateCommercialProps,
  NewFlatCardTwoStatesProps,
} from '../NewFlatCardTwoStates/NewFlatCardTwoStates.types'
import NewFlatCardTwoStatesCommercial from '../NewFlatCardTwoStates/NewFlatCardTwoStatesCommercial'
import LastFlatCard from '../UI/LastFlatCard/LastFlatCard'
import { NewCardsProps } from './NewCards.types'

const cardsAnalyticsHandler = (isOpen: boolean, position: string) => {
  ReactGA.ga(
    'send',
    'event',
    'main',
    `projects ${position} list`,
    isOpen ? 'hide' : 'show'
  )
  ym('reachGoal', 'projects list click', {
    'projects list click': {
      position: {
        'click type': isOpen ? 'hide' : 'show',
      },
    },
  })
}

const startItems = 4

export const NewCards = (props: NewCardsProps) => {
  const {
    cards,
    SelectionId,
    showALL,
    position = 'bottom',
    linkLastCard,
    type = 'flat',
  } = props
  const [itemsCount, setItemsCount] = useState<number | undefined>(
    showALL ? undefined : startItems
  )
  const cardsRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)

  const showMore = () => {
    setItemsCount(isOpen ? startItems : undefined)
    setIsOpen(!isOpen)

    cardsAnalyticsHandler(isOpen, position)

    if (isOpen && cardsRef.current) {
      window.scrollTo(0, cardsRef.current.offsetTop)
    }
  }

  return (
    <div className='new-cards' ref={cardsRef}>
      <div className='new-cards__items'>
        {cards.slice(0, itemsCount).map((card: any) => (
          <div key={card.id}>
            {type === 'commercial' ? (
              <NewFlatCardTwoStatesCommercial
                {...card}
                selectionId={SelectionId}
              />
            ) : (
              <NewFlatCardTwoStates {...card} selectionId={SelectionId} />
            )}
          </div>
        ))}

        {!itemsCount && (
          <div>
            <LastFlatCard link={linkLastCard} type={type} />
          </div>
        )}
      </div>
      {!showALL && (
        <div className='new-cards__btn'>
          <button className='btn btn--gray' onClick={showMore}>
            {!itemsCount ? 'Скрыть все' : 'Показать все'}
          </button>
        </div>
      )}
    </div>
  )
}
